
import type { Direction } from '@fleetduel/shared'

interface DirectionPickerProps {
  direction: Direction
  onChange: (dir: Direction) => void
}

export function DirectionPicker({ direction, onChange }: DirectionPickerProps) {
  return (
    <div style={{ display: 'flex', gap: 4 }}>
      <button
        onClick={() => onChange('horizontal')}
        style={{
          padding: '6px 12px',
          fontSize: 12,
          border: 'none',
          borderRadius: 4,
          cursor: 'pointer',
          backgroundColor: direction === 'horizontal' ? '#1976d2' : '#263238',
          color: '#fff',
        }}
      >
        Horizontal
      </button>
      <button
        onClick={() => onChange('vertical')}
        style={{
          padding: '6px 12px',
          fontSize: 12,
          border: 'none',
          borderRadius: 4,
          cursor: 'pointer',
          backgroundColor: direction === 'vertical' ? '#1976d2' : '#263238',
          color: '#fff',
        }}
      >
        Vertical
      </button>
    </div>
  )
}
